export default function setLoading(condition) {
  return {
    type: "setLoading",
    payload: condition
  }
}